module.exports = __webpack_public_path__ + "img/logo_inline.c5ba2af.png";